import styled from 'styled-components';

export const backgroundColors = {
  success: 'var(--color-success)',
  error: 'var(--color-error)',
  notice: 'var(--color-primary-box-background)',
};

export const textColors = {
  success: 'var(--color-text-bright)',
  error: 'var(--color-text-bright)',
  notice: 'var(--color-text-default)',
};

export type MessageType = 'success' | 'error' | 'notice';

const Alert = styled.div <{ $type: MessageType }>`
  display: flex;
  align-items: center;
  font-size: var(--font-size-default);
  color: ${({ $type }) => textColors[$type]};
  background-color: ${({ $type }) => backgroundColors[$type]};
  padding: 8px;
  border-radius: var(--border-box-radius);
`;

export default Alert;
